<template>
  <v-app>
    <!--INDICA LA PÁGINA EN LA QUE SE ENCUETRA-->
    <v-card class="grlCardInfo">
      <v-breadcrumbs :items="obtRuta" class="grlClase">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item @click="insertarRuta(item.ruta)" :disabled="item.disabled">
            {{ item.text.toUpperCase() }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </v-card>
    <!--IMAGEN Y TITULO DE LA PÁGINA-->
    <v-card>
      <v-img :src="imgTitle" class="grlCardImg">
        <div class="grlCardInfo">
          <h1 class="my-auto hidden-sm-and-down">Ingeniero Agrónomo con especialidad en Fitotecnia</h1>
        </div>
      </v-img>
    </v-card>
    <!---->
    <div class="gralMargenes" id="gralEspaciado" style="text-align: justify">
      <hr />
      <h4 class="gralTitulosLic">Descripcion</h4>
      <p class="estiloBoxLic">
        El Ingeniero Agrónomo Fitotecnista debe tener un conocimiento integral de los factores que
        intervienen en la producción agropecuaria, basado en un enfoque ambiental, humanista, socioeconómico y de
        desarrollo que requiere la sociedad. Logrando aptitudes y actitudes que le permitan competir a nivel regional,
        nacional e internacional con una visión global e integradora, al privilegiar una conciencia social, sustentable y
        propositiva. El Agrónomo Fitotecnista se conceptualiza como un profesional cuya formación le permite dar solución
        a problemas tecnológicos, ecológicos y productivos desde una perspectiva holística y sustentable, mediante la
        aplicación de una visión científica y humanista con sentido crítico, creativo y de servicio.
      </p>
      <h4 class="gralTitulosLic">Más Infromación</h4>
      <v-card class="estiloCardLic">
        <v-tabs>
          <v-tabs-slider color="yellow"></v-tabs-slider>
          <v-tab>Misión</v-tab>
          <v-tab>Visión</v-tab>
          <v-tab>Meta</v-tab>
          <v-tab>Perfil de Ingreso</v-tab>
          <v-tab>Perfil de Egreso</v-tab>
          <v-tab>Plan de Estudios</v-tab>
          <!--MISION-->
          <v-tab-item class="estiloBoxLic">
            <v-container>
              <!--MISION-->
              <p>El Programa Educativo tiene la Misión de formar profesionistas críticos, creativos, innovadores, con
                conocimientos científicos y tecnológicos en el área de la Fitotecnia, comprometidos con la sociedad y el
                desarrollo sustentable, capaces de plantear, analizar y solucionar problemas agropecuarios con creatividad
                y calidad, permitiéndoles insertarse con éxito en un mercado laboral competitivo y globalizado.</p>
            </v-container>
          </v-tab-item>
          <!--VISION-->
          <v-tab-item class="estiloBoxLic">
            <v-container>
              <!--VISION-->
              <p>El Plan de Estudios de Ingeniero agrónomo Fitotecnista aspira a ser uno de los mejores incidiendo de
                manera importante en el desarrollo del sector agropecuario y con reconocimiento local, nacional e
                internacional.</p>
            </v-container>
          </v-tab-item>
          <!--META-->
          <v-tab-item class="estiloBoxLic">
            <v-container>
              <!--META-->
              <p>El Ingeniero Agrónomo Fitotecnista egresado deberá poseer y mantener altos índices de competitividad,
                superando estándares de calidad, al incluir la inocuidad como componente básico, aumentando el volumen de
                producción agropecuaria, mejorando la eficiencia del recurso humano, haciendo un uso más eficiente de los
                insumos y cumpliendo con los principios de responsabilidad social y ambiental; lo anterior al utilizar los
                métodos, las técnicas y los procedimientos resultado de su proceso de formación.
              </p>
            </v-container>
          </v-tab-item>
          <!--PERFIL DE INGRESO-->
          <v-tab-item class="estiloBoxLic">
            <!--PERFIL DE INGRESO-->
            <v-container>
              <span class="title">
                <strong>Perfil y Requisitos de ingreso</strong>
              </span>
              <br>
              <br>
              <p>
                Los aspirantes a la carrera de Ingeniero Agrónomo Fitotecnista deben contar con:
              </p>
              <br>
              <span class="subtitle"><strong>CONOCIMIENTOS</strong></span>
              <hr>
              <p>
                Básicos en ciencias:
              <ul>
                <li>Matemáticas.</li>
                <li>Biológicas.</li>
                <li>Físicas.</li>
                <li>Químicas.</li>
                <li>Ecológicas.</li>
                <li>Económico – Administrativas.</li>
                <li>Humanidades.</li>
                <li>Informática.</li>
                <li>Además de Técnicas de investigación documental.</li>
              </ul>
              </p>
              <br>
              <br>
              <!-- NEWS TABLE 2 -->
              <span class="subtitle"><strong>HABILIDADES Y DESTREZAS</strong></span>
              <hr>
              <p>
              <ul>
                <li>Habilidad para el trabajo en equipo.</li>
                <li>Destreza para el trabajo bajo presión.</li>
                <li>Capacidad para comprender fenómenos biológicos.</li>
                <li>Habilidades para desarrollar labores de campo.</li>
                <li>Capacidad de relacionarse con el sector agrícola.</li>
                <li>Desempeñarse satisfactoriamente en el medio rural e identificarse con el mismo.</li>
                <li>Hábitos de estudio.</li>
                <li>Interés en mantener contacto con la naturaleza.</li>
                <li>Atracción por las actividades que se desarrollan al aire libre.</li>
                <li>Capacidad creativa para saber coordinar, articular, potenciar fortalezas, incluir divergencias y
                  motivar la participación de los diferentes agentes sociales e institucionales.</li>
                <li>Interés por la solución de los problemas de los sistemas de producción agrícola y pecuaria.</li>
                <li>Visión empresarial.</li>
              </ul>
              </p>
              <br>
              <br>
              <!-- NEWS TABLE 2 -->
              <span class="subtitle"><strong>ACTITUDES</strong></span>
              <hr>
              <p>
              <ul>
                <li>Responsabilidad.</li>
                <li>Disponibilidad.</li>
                <li>Interés por poseer conocimientos amplios y diversos.</li>
                <li>Actitudes honestas y éticas.</li>
                <li>Vocación social y de apoyo.</li>
                <li>Interés por el uso y manejo óptimo de los recursos agropecuarios y naturales.</li>
                <li>Preocuparse y ocuparse por el mejoramiento social, cultural y económico de la sociedad.</li>
                <li>Iniciativa.</li>
                <li>Respeto así mismo y a los demás.</li>
                <li>Compromiso.</li>
                <li>Lealtad.</li>
                <li>Disciplina.</li>
                <li>Creatividad.</li>
                <li>Organización</li>
                <li>Tolerancia</li>
                <li>Disponibilidad.</li>
              </ul>
              </p>
              <br>
              <br>
              <!-- NEWS TABLE 2 -->
              <span class="subtitle"><strong>APTITUDES</strong></span>
              <hr>
              <p>
              <ul>
                <li>Utilizar eficientemente sistemas de cómputo y manejar bancos de información.</li>
                <li>Relacionarse de manera fácil y sencilla con personas de nivel socio económico diverso.</li>
                <li>Manejar de manera correcta el instrumental científico, equipo y maquinaria.</li>
                <li>Comunicarse de manera táctica y estratégica.</li>
              </ul>
              </p>
              <br>
              <br>
              <!-- NEWS TABLE 2 -->
              <span class="subtitle"><strong>REQUISITOS DE INGRESO</strong></span>
              <hr>
              <p>
                El aspirante a cursar el programa de estudios de la carrera de Ingeniero Agrónomo Fitotecnista en la
                Facultad de Agricultura y Zootecnia deberá presentar la siguiente documentación de acuerdo al artículo 39
                del Reglamento General de la Universidad Juárez del Estado de Durango.
                <br>
              <ul>
                <li>Llenar la solicitud de inscripción correspondiente.</li>
                <li>6 Fotografías tamaño infantil de frente en blanco y negro o a color.</li>
                <li>Certificado original de enseñanza secundaria y dos copias.</li>
                <li>Certificado o Constancia original de enseñanza preparatoria y dos fotocopias.</li>
                <li>Certificado de salud reciente de dependencia oficial (IMSS, ISSSTE, SSA,).</li>
                <li>Carta de antecedentes no penales.</li>
                <li>Acta de nacimiento certificada original y dos fotocopias.</li>
                <li>Aprobar requisitos de admisión.</li>
                <li>Pagar ficha examen diagnostico.</li>
                <li>Pagar inscripción al 1er Semestre.</li>
              </ul>
              </p>
            </v-container>
          </v-tab-item>
          <!--PERFIL DE EGRESO-->
          <v-tab-item class="estiloBoxLic">
            <v-container>
              <span class="title">
                <strong>PERFIL Y REQUISITOS DE EGRESO</strong>
              </span>
              <br>
              <br>
              <p>
                El egresado de la licenciatura de Ingeniero Agrónomo Fitotecnista es el profesional capacitado para
                aplicar técnicas en la producción agropecuaria, manejo integrado de plagas y enfermedades, diagnóstico e
                interpretación de análisis de suelo para eficientar los procesos productivos, uso sustentable del agua
                bajo métodos y sistemas de riego, analizar y aplicar los procesos fisiológicos ambientales que permitan
                maximizar el potencial productivo, así como la transformación, industrialización y calidad integral de los
                productos agrícolas, la administración de procesos productivos de empresas agrícolas para la obtención de
                producciones económicamente rentables e innovadoras de una manera racional y con respeto al medio
                ambiente; además de estar capacitado para desarrollar las siguientes competencias profesionales:
                <br>
                <br>
              <ol>
                <li>Comprender y aplicar en la producción agropecuaria bajo los sistemas intensivos, extensivos y
                  orgánicos con enfoque integral, competitivo y consciente de la conservación del ambiente, así como su
                  papel en la productividad, calidad y comercialización a nivel regional, nacional e internacional, con
                  actitud ética, creativa, solidaria con la sociedad, respeto al ambiente y con sentido sustentable..</li>
                <li>Deberá aplicar los conocimientos de economía, administración, mercadotecnia y recursos humanos en la
                  formulación y evaluación de proyectos agropecuarios de producción y desarrollo, con apego a la
                  legislación y normatividad vigente que coadyuve al desarrollo económico del país, con sentido social,
                  objetividad y pertinencia..</li>
                <li>Diseñar y dirigir procesos de validación e interpretación de información pertinente, aplicando el
                  método científico en los sistemas de producción agropecuarios, con visión integradora, como alternativas
                  de solución a problemas técnicos, de calidad, inocuidad, desarrollo, organización, validación y
                  transferencia de tecnología, con actitud ética, creativa, solidaria con la sociedad, respeto al ambiente
                  y con sentido sustentable..</li>
                <li>Comprenderá la biología de los principales organismos y microorganismos que afectan los cultivos y su
                  control con un método integral de protección. Conocerá la importancia de la estructura, morfología y
                  fisiología de las plantas para su manejo y explotación, para el diseño de variables agronómicas que
                  determinan la productividad de los cultivos en un ambiente determinado..</li>
                <li>Deberá aplicar los conocimientos de la herencia y variación, así como su relación con el medio
                  ambiente en el mejoramiento genético a nivel tradicional y biotecnológico, y además en el rescate,
                  conservación y protección de los recursos genéticos naturales con potencial económico, así como en el
                  resguardo y conservación de los ya mejorados, con actitud ética, creativa, solidaria con la sociedad,
                  respeto al ambiente y con sentido sustentable..</li>
                <li>Utilizará los conocimientos de las propiedades físicas, químicas y biológicas del SUELO Y AGUA para
                  comprender la importancia de su manejo como un complejo dinámico interrelacionado con el clima y planta,
                  y de esta manera diseñar programas de manejo y fertilización en forma integral y sustentable..</li>
              </ol>
              </p>
              <br>
              <br>
              <!-- NEWS TABLE 2 -->
              <span class="subtitle"><strong>REQUISITOS DE EGRESO</strong></span>
              <hr>
              <p>
                Se considera egreso, cuando el alumno obtenga los conocimientos, habilidades y actitudes vinculadas a esta
                disciplina.
                <br>
                <br>
              <ul>
                <li>Cubrir la totalidad de las asignaturas obligatorias y optativas del plan de estudios.</li>
                <li>Cubrir el total de 384 créditos repartidos de la siguiente manera: 92 del área básica, 178 del área
                  disciplinaria, 78 del área terminal, 12 del área integral (arte, cultura, deportes), 12 de experiencia
                  recepcional (proyectos, tesis o tesina), 12 del servicio social.</li>
                <li>No tener adeudo económico, material, equipo de campo, laboratorio y biblioteca.</li>
                <li>Aprobar los requisitos que se determinen para el idioma ingles.</li>
                <li>Prácticas profesionales.</li>
                <li>Servicio social.</li>
                <li>Experiencia recepcional.</li>
                <li>Actividades integrales.</li>
                <li>Cubrir el requisito de lengua extranjera.</li>
                <li>Titulación. El alumno deberá presentar como requisitos de titulación:.
                  <ul>
                    <li>Certificado de Servicio Social.</li>
                    <li>Documento que avale la realización de prácticas profesionales expedido por Organismo público,
                      privado o social..</li>
                    <li>Certificado de Estudios comprobatorio de promoción de las asignaturas en un total de 384 créditos.
                    </li>
                    <li>Elegir una de las modalidades de titulación aprobadas por la H. Junta Directiva de la Universidad
                      Juárez del Estado de Durango.</li>
                  </ul>
                </li>
              </ul>
              </p>
            </v-container>
          </v-tab-item>
          <!--PLAN DE ESTUDIOS-->
          <v-tab-item class="estiloBoxLic">
            <v-container>
              <v-img :src="imgReticula"></v-img>
            </v-container>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </div>
  </v-app>
</template>
<script>

export default {
  data: () => ({
    img: require('../../assets/img/logo_ujed.png'),
    imgReticula: require('../../assets/img/plan-estudios-fitotecnia.jpg'),
    imgTitle: require('../../assets/img/banner-OE.jpg'),
    obtRuta: [
      {
        text: 'Inicio',
        disabled: false,
        ruta: '/',
      },
      {
        text: 'Oferta Educativa',
        disabled: true,
        ruta: '/',
      },
      {
        text: 'Licenciaturas',
        disabled: false,
        ruta: '/licenciaturas',
      },
      {
        text: '',
        disabled: true,
        ruta: '/licenciaturas',
      },
    ],
  }),
  methods: {
    insertarRuta(ruta) {
      this.$router.push(ruta);
    },
  },
};
</script>
<style>
.estiloBoxLic{
  padding: 1%;
}
.estiloCardLic{
  margin: 1%;
}
</style>
  